import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../db/models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private baseUrl = 'https://api.trepezserver.com/api/user/';
  // private baseUrl = 'https://localhost:44352/api/user/';

constructor(private http: HttpClient) { }

  getUsers(): Observable<User[]> {
  return this.http.get<User[]>(this.baseUrl + 'users');
  }

  getUserDetails(id: string): Observable<User> {
    return this.http.get<User>(this.baseUrl + 'user/' + id);
  }

  addUser(user: User): Observable<User> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
     return this.http.post<User>(this.baseUrl + 'newUser', user, { headers });
   }

   updateUser(user: User): Observable<User> {
     const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
     return this.http.put<User>(this.baseUrl + 'updateUser/' + user.id, user, { headers });
   }

   deleteUser(id: string): Observable<{}> {
     const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
     return this.http.delete<User>(this.baseUrl + 'deleteUser/' + id,
       httpOptions);
   }

}
